import type { GetStaticProps } from 'next';
import { NoSSR } from '@/components';
import { getDefaultStaticProps } from '@/utils/next';
import { QuoteResultPageView } from './QuoteResultPageView';
const QuoteResultPage = () => <NoSSR data-sentry-element="NoSSR" data-sentry-component="QuoteResultPage" data-sentry-source-file="index.page.tsx">
    <QuoteResultPageView data-sentry-element="QuoteResultPageView" data-sentry-source-file="index.page.tsx" />
  </NoSSR>;
export const getStaticProps: GetStaticProps = ctx => getDefaultStaticProps({
  ...ctx,
  namespaces: ['common', 'billing']
});
export default QuoteResultPage;